import React, { useEffect, useState } from "react";
import { Layout, message, Spin } from "antd";

import Sidebar from "../Sidebar";
import Header from "../Header";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { portalService } from "../../../configs/constants";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { getDefaultNav } from "../../../utils/helper";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const { Content } = Layout;

const DashboardLayout = (props) => {
  const [menuList, setMenuList] = useState(null);
  const navigate = useNavigate();
  const [rootLoad, setRootLoad] = useState(false);
  const mockData = {
    data: {
      data: [
        {
          features: [
            "APPNOTIFICATION",
            "EDITHTML",
            "POPNOTIFICATION",
            "SMS",
            "WHATSAPP",
          ],
          value: "comm",
          label: "Communication",
        },
        { features: [], value: "settings", label: "Control Center" },
        { features: [], value: "ticketing", label: "Ticketing Center" },
        { features: [], value: "RtaPermit", label: "RTA Permit" },
        {
          features: ["assignShift", "createProvider"],
          value: "roaster",
          label: "Calendar",
        },
      ],
    },
    status: 200,
    statusText: "",
    headers: {
      "company-code": '["6711","6721","6731","6741"]',
      "content-length": "271",
      "content-type": "application/json; charset=utf-8",
    },
    config: {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false,
      },
      adapter: ["xhr", "http", "fetch"],
      transformRequest: [null],
      transformResponse: [null],
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {},
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/x-www-form-urlencoded",
        "company-code": "6711",
      },
      withCredentials: true,
      method: "post",
      url: "https://makkahqa.agp-dev.com/qa/carstaxi/portal/acl/my-permission",
      allowAbsoluteUrls: true,
    },
    request: {},
  };


  useEffect(() => {
    const getMyPermissions = async () => {
      let userInfo = JSON.parse(window.localStorage.getItem("login-response"));

      await axios
        .post(`${portalService}/acl/my-permission`)
        .then((res) => {
          const foundTicketing = res?.data?.data.find(
            (menu) => menu.value === "ticketing"
          );
          if (!foundTicketing) {
            res?.data?.data.push({
              features: [],
              value: "ticketing",
              label: "Ticketing Center",
            });
          }
          const codes = res.headers["company-code"];
          codes &&
            window.localStorage.setItem("companyCodes", JSON.stringify(codes));
          window.localStorage.setItem("menu-list", JSON.stringify(res?.data));
          const sortedMenu = _.sortBy(res?.data?.data, "label");
          setMenuList(sortedMenu);
          if (res?.data?.data.length === 1) {
            setTimeout(() => {
              navigate("/ticketing");
            }, 1100);
          }
        })
        .catch((err) => message.error("Unable to load permissions."));
    };

    setRootLoad(true);
    setTimeout(async () => {
      await getMyPermissions();
      setRootLoad(false);
    }, 2000);
  }, []);
  return (
    <Layout className="main-layout">
      <Header />
      <Spin
        spinning={rootLoad}
        indicator={antIcon}
        tip={"Fetching permissions"}
        style={{ position: "fixed" }}
      >
        <Layout>
          <Sidebar menuList={menuList} />
          <Layout className="layout-space">
            {!rootLoad && (
              <Spin
                spinning={props.load || false}
                indicator={antIcon}
                style={{ position: "fixed" }}
              >
                <Content className="main-content">{props.children}</Content>
              </Spin>
            )}
          </Layout>
        </Layout>
      </Spin>
    </Layout>
  );
};

export default DashboardLayout;
